import LandingPageComposition from '@tcs/create-account/containers/LandingPageComposition';
import usePartnerConfig from '@tcs/create-account/hooks/usePartnerConfig';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import CreateAccount404 from '../404';

const PartnerPage = () => {
  const { partnerId } = useParams();
  const { loading, data } = usePartnerConfig(partnerId);
  const nav = useNavigate();

  useEffect(() => {
    if (loading) {
      return;
    }
    if (data && !data.landingPage) {
      nav(`/${partnerId}/steps`);
    }
  }, [nav, data, partnerId, loading]);

  if (loading) {
    return null; //todo: spinner
  }

  if (!data) {
    return <CreateAccount404 />;
  }

  const { header, footer, landingPage } = data;

  return landingPage ? (
    <LandingPageComposition
      header={header}
      page={landingPage}
      footer={footer}
    />
  ) : null;
};

export default PartnerPage;
